import { createActions } from "redux-actions";

export const SEND_ZOHO = "SEND_ZOHO";
export const SEND_ZOHO_DONE = "SEND_ZOHO_DONE";
export const UPDATE_ZOHO_DONE = "UPDATE_ZOHO_DONE";
export const UPDATE_CRM_DONE = "UPDATE_CRM_DONE";
export const LOAD_CHANNEL = "LOAD_CHANNEL";
export const LOAD_CHANNEL_DONE = "LOAD_CHANNEL_DONE";
export const OPEN_COVERAGE_INFO_MODAL = "OPEN_COVERAGE_INFO_MODAL";
export const CLOSE_COVERAGE_INFO_MODAL = "CLOSE_COVERAGE_INFO_MODAL";
export const INITIALIZE_QUOTATION_FLOW = "INITIALIZE_QUOTATION_FLOW";
export const INITIALIZE_QUOTATION_FLOW_DONE = "INITIALIZE_QUOTATION_FLOW_DONE";
export const SAVE_PERSONAL_DATA = "SAVE_PERSONAL_DATA";
export const SAVE_PERSONAL_DATA_DONE = "SAVE_PERSONAL_DATA_DONE";
export const SAVE_HOUSING_INFO = "SAVE_HOUSING_INFO";
export const SAVE_HOUSING_INFO_DONE = "SAVE_HOUSING_INFO_DONE";
export const SAVE_GUESS_PRICE = "SAVE_GUESS_PRICE";
export const SAVE_GUESS_PRICE_DONE = "SAVE_GUESS_PRICE_DONE";
export const SAVE_PLAN_CUSTOM = "SAVE_PLAN_CUSTOM";
export const SAVE_PLAN_CUSTOM_DONE = "SAVE_PLAN_CUSTOM_DONE";
export const DO_PAYMENT = "DO_PAYMENT";
export const DO_PAYMENT_DONE = "DO_PAYMENT_DONE";
export const GO_NEXT_STEP = "GO_NEXT_STEP";
export const TOGGLE_SELECTED_COVERAGE = "TOGGLE_SELECTED_COVERAGE";
export const TOGGLE_SELECTED_MULTIPLE_COVERAGES = "TOGGLE_SELECTED_MULTIPLE_COVERAGES";
export const TOGGLE_ASSISTANT_PACKAGE = "TOGGLE_ASSISTANT_PACKAGE";
export const UPDATE_HOUSING_INFO_FORM = "UPDATE_HOUSING_INFO_FORM";
export const UPDATE_GUESS_PRICE_FORM = "UPDATE_GUESS_PRICE_FORM";
export const DO_CONFIRM = "DO_CONFIRM";
export const LOAD_UBIGEOS = "LOAD_UBIGEOS";
export const SET_UBIGEOS = "SET_UBIGEOS";
export const UPDATE_RECOMMENDED_COVERAGES = "UPDATE_RECOMMENDED_COVERAGES";
export const ADD_RECOMMENDED_COVERAGES = "ADD_RECOMMENDED_COVERAGES";
export const UPDATE_QUOTATION_PRICE = "UPDATE_QUOTATION_PRICE";
export const CALCULATE_HOME_PRICE = "CALCULATE_HOME_PRICE";
export const CALCULATE_HOME_PRICE_DONE = "CALCULATE_HOME_PRICE_DONE";
export const RESET_CALCULATOR = "RESET_CALCULATOR";
export const SEE_MORE_IN_LANDING = "SEE_MORE_IN_LANDING";
export const CALCULATE_REFERENTIAL_VALUE = "CALCULATE_REFERENTIAL_VALUE";
export const SET_REFERENTIAL_VALUE = "SET_REFERENTIAL_VALUE";
export const SAVE_ADDRESS_INFO = "SAVE_ADDRESS_INFO";
export const SAVE_ADDRESS_INFO_DONE = "SAVE_ADDRESS_INFO_DONE";
export const CALCULATE_TOTAL_PRICE = "CALCULATE_TOTAL_PRICE";
export const REQUEST_LOAD_COMPONENTS_PRELOADER = "REQUEST_LOAD_COMPONENTS_PRELOADER";
export const SUCCESS_LOAD_COMPONENTS_PRELOADER = "SUCCESS_LOAD_COMPONENTS_PRELOADER";
export const REQUEST_LOAD_QUOTE_POPUP = "REQUEST_LOAD_QUOTE_POPUP";
export const SUCCESS_LOAD_QUOTE_POPUP = "SUCCESS_LOAD_QUOTE_POPUP";
export const DISABLE_DEPENDENT_COVERAGES = "DISABLE_DEPENDENT_COVERAGES";
export const DISABLE_DEPENDENT_COVERAGES_DONE = "DISABLE_DEPENDENT_COVERAGES_DONE";
export const VALIDATE_MIN_PRIME = "VALIDATE_MIN_PRIME";
export const WHO_CAN_HIRE_MODAL_SET_OPEN = "WHO_CAN_HIRE_MODAL_SET_OPEN";
export const SECURITY_SYSTEM_MODAL_SET_OPEN = "SECURITY_SYSTEM_MODAL_SET_OPEN";
export const LOAD_ACTIVE_PROMOTION = "LOAD_ACTIVE_PROMOTION";
export const LOAD_ACTIVE_PROMOTION_DONE = "LOAD_ACTIVE_PROMOTION_DONE";
export const VALIDATE_IF_DOCUMENT_NUMBER_EXISTS = "VALIDATE_IF_DOCUMENT_NUMBER_EXISTS";
export const VALIDATE_IF_DOCUMENT_NUMBER_EXISTS_DONE =
    "VALIDATE_IF_DOCUMENT_NUMBER_EXISTS_DONE";
export const SET_FIXED_PLAN_SELECTION = "SET_FIXED_PLAN_SELECTION";
export const START_QUOTE_PROCESS = "START_QUOTE_PROCESS";
export const START_QUOTE_PROCESS_DONE = "START_QUOTE_PROCESS_DONE";
export const UPDATE_HOUSING_VALUE = "UPDATE_HOUSING_VALUE";
export const UPDATE_ASSETS_VALUE = "UPDATE_ASSETS_VALUE";
export const SAVE_INITIAL_HOUSE_INFORMATION = "SAVE_INITIAL_HOUSE_INFORMATION";
export const SEND_CRM_ORACLE_REGISTER_CONTACT = "SEND_CRM_ORACLE_REGISTER_CONTACT";
export const SEND_CRM_ORACLE_GET_CUSTOMER = "SEND_CRM_ORACLE_GET_CUSTOMER";
export const SEND_CRM_ORACLE_CREATE_CUSTOMER = "SEND_CRM_ORACLE_CREATE_CUSTOMER";
export const SEND_CRM_ORACLE_CREATE_OPPORTUNITY = "SEND_CRM_ORACLE_CREATE_OPPORTUNITY";
export const UPDATE_CRM_ORACLE = "UPDATE_CRM_ORACLE";
export const UPDATE_CRM_ORACLE_OPTY_NUMBER = "UPDATE_CRM_ORACLE_OPTY_NUMBER";
export const UPDATE_CRM_ORACLE_INITIAL_DATA = "UPDATE_CRM_ORACLE_INITIAL_DATA";
export const UPDATE_CRM_ORACLE_QUOTE = "UPDATE_CRM_ORACLE_QUOTE";
export const UPDATE_CRM_ORACLE_DATA = "UPDATE_CRM_ORACLE_DATA";
export const UPDATE_CRM_ORACLE_PAYMENT = "UPDATE_CRM_ORACLE_PAYMENT";
export const UPDATE_CRM_ORACLE_END = "UPDATE_CRM_ORACLE_END"
export const {
    initializeQuotationFlow,
    initializeQuotationFlowDone,
    savePersonalData,
    savePersonalDataDone,
    saveHousingInfo,
    saveHousingInfoDone,
    saveGuessPrice,
    saveGuessPriceDone,
    savePlanCustom,
    savePlanCustomDone,
    doPayment,
    doPaymentDone,
    goNextStep,
    toggleSelectedCoverage,
    toggleSelectedMultipleCoverages,
    toggleAssistantPackage,
    loadUbigeos,
    setUbigeos,
    updateRecommendedCoverages,
    addRecommendedCoverages,
    updateQuotationPrice,
    calculateHomePrice,
    calculateHomePriceDone,
    resetCalculator,
    seeMoreInLanding,
    calculateReferentialValue,
    setReferentialValue,
    saveAddressInfo,
    saveAddressInfoDone,
    openCoverageInfoModal,
    closeCoverageInfoModal,
    calculateTotalPrice,
    requestLoadComponentsPreloader,
    successLoadComponentsPreloader,
    requestLoadQuotePopup,
    successLoadQuotePopup,
    disableDependentCoverages,
    disableDependentCoveragesDone,
    validateMinPrime,
    loadChannel,
    loadChannelDone,
    sendZoho,
    sendZohoDone,
    updateZohoDone,
    updateCrmDone,
    whoCanHireModalSetOpen,
    securitySystemModalSetOpen,
    loadActivePromotion,
    loadActivePromotionDone,
    validateIfDocumentNumberExists,
    validateIfDocumentNumberExistsDone,
    setFixedPlanSelection,
    startQuoteProcess,
    startQuoteProcessDone,
    updateHousingValue,
    updateAssetsValue,
    saveInitialHouseInformation,
    sendCrmOracleGetCustomer,
    updateCrmOracle,
    updateCrmOracleOptyNumber,
    sendCrmOracleCreateCustomer,
    sendCrmOracleCreateOpportunity,
    updateCrmOracleInitialData,
    updateCrmOracleQuote,
    updateCrmOracleData,
    updateCrmOraclePayment,
    updateCrmOracleEnd
} = createActions(
    {
        [REQUEST_LOAD_QUOTE_POPUP]: () => ({
            quotePopup: {
                isLoadRequested: true,
                isLoadSuccess: false,
            },
        }),
        [SUCCESS_LOAD_QUOTE_POPUP]: () => ({
            quotePopup: {
                isLoadRequested: true,
                isLoadSuccess: true,
            },
        }),
        [REQUEST_LOAD_COMPONENTS_PRELOADER]: () => ({
            preloadComponents: {
                isLoadRequested: true,
                isLoadSuccess: false,
            },
        }),
        [SUCCESS_LOAD_COMPONENTS_PRELOADER]: () => ({
            preloadComponents: {
                isLoadRequested: true,
                isLoadSuccess: true,
            },
        }),
        [OPEN_COVERAGE_INFO_MODAL]: payload => ({
            coverageCode: payload.code || payload,
            variant: payload.variant || null,
        }),
    },
    ...[
        INITIALIZE_QUOTATION_FLOW,
        INITIALIZE_QUOTATION_FLOW_DONE,
        SAVE_PERSONAL_DATA,
        SAVE_PERSONAL_DATA_DONE,
        SAVE_HOUSING_INFO,
        SAVE_HOUSING_INFO_DONE,
        SAVE_GUESS_PRICE,
        SAVE_GUESS_PRICE_DONE,
        SAVE_PLAN_CUSTOM,
        SAVE_PLAN_CUSTOM_DONE,
        DO_PAYMENT,
        DO_PAYMENT_DONE,
        TOGGLE_SELECTED_COVERAGE,
        TOGGLE_SELECTED_MULTIPLE_COVERAGES,
        TOGGLE_ASSISTANT_PACKAGE,
        LOAD_UBIGEOS,
        SET_UBIGEOS,
        UPDATE_RECOMMENDED_COVERAGES,
        ADD_RECOMMENDED_COVERAGES,
        UPDATE_QUOTATION_PRICE,
        GO_NEXT_STEP,
        CALCULATE_HOME_PRICE,
        CALCULATE_HOME_PRICE_DONE,
        RESET_CALCULATOR,
        SEE_MORE_IN_LANDING,
        CALCULATE_REFERENTIAL_VALUE,
        SET_REFERENTIAL_VALUE,
        SAVE_ADDRESS_INFO,
        SAVE_ADDRESS_INFO_DONE,
        CLOSE_COVERAGE_INFO_MODAL,
        CALCULATE_TOTAL_PRICE,
        DISABLE_DEPENDENT_COVERAGES,
        DISABLE_DEPENDENT_COVERAGES_DONE,
        VALIDATE_MIN_PRIME,
        LOAD_CHANNEL,
        LOAD_CHANNEL_DONE,
        SEND_ZOHO,
        SEND_ZOHO_DONE,
        UPDATE_ZOHO_DONE,
        UPDATE_CRM_DONE,
        WHO_CAN_HIRE_MODAL_SET_OPEN,
        SECURITY_SYSTEM_MODAL_SET_OPEN,
        LOAD_ACTIVE_PROMOTION,
        LOAD_ACTIVE_PROMOTION_DONE,
        VALIDATE_IF_DOCUMENT_NUMBER_EXISTS,
        VALIDATE_IF_DOCUMENT_NUMBER_EXISTS_DONE,
        SET_FIXED_PLAN_SELECTION,
        START_QUOTE_PROCESS,
        START_QUOTE_PROCESS_DONE,
        UPDATE_HOUSING_VALUE,
        UPDATE_ASSETS_VALUE,
        SAVE_INITIAL_HOUSE_INFORMATION,
        SEND_CRM_ORACLE_GET_CUSTOMER,
        SEND_CRM_ORACLE_CREATE_CUSTOMER,
        UPDATE_CRM_ORACLE,
        UPDATE_CRM_ORACLE_OPTY_NUMBER,
        SEND_CRM_ORACLE_REGISTER_CONTACT,
        SEND_CRM_ORACLE_CREATE_OPPORTUNITY,
        UPDATE_CRM_ORACLE_INITIAL_DATA,
        UPDATE_CRM_ORACLE_QUOTE,
        UPDATE_CRM_ORACLE_DATA,
        UPDATE_CRM_ORACLE_PAYMENT,
        UPDATE_CRM_ORACLE_END
    ]
);
